import { render, staticRenderFns } from "./UiImage.vue?vue&type=template&id=c7cbba4e&"
import script from "./UiImage.vue?vue&type=script&lang=js&"
export * from "./UiImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports